import React from "react";
import VANOtable from "./VANOtable";

function VANOHome() {
  return (
    <div className="flex flex-col">
      {/* Admin view */}
      <VANOtable />
    </div>
  );
}

export default VANOHome;
